import { render, staticRenderFns } from "./Forget.vue?vue&type=template&id=017cf63a&scoped=true&"
import script from "./Forget.js?vue&type=script&lang=js&"
export * from "./Forget.js?vue&type=script&lang=js&"
import style0 from "./Forget.vue?vue&type=style&index=0&id=017cf63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017cf63a",
  null
  
)

export default component.exports